import { DECREMENT_COUNTER, INCREMENT_COUNTER } from '@store/action-types/counter';

const incrementCounter = () => ({ type: INCREMENT_COUNTER });
const decrementCounter = () => ({ type: DECREMENT_COUNTER });

export { incrementCounter, decrementCounter };
